import { type Loadable, asyncReadable, derived } from '@square/svelte-store'
import { AllTranslationsDocument, type Query, type TranslationRecord } from 'datocms/models'
import { request } from 'datocms/request'

export type LanguageItem = Pick<TranslationRecord, 'id' | 'code' | 'name' | 'beta'>

export const translations: Loadable<TranslationRecord[]> = asyncReadable(
	[],
	async () => {
		const response = await request<Query>(AllTranslationsDocument)

		return response.allTranslations
	},
	{ reloadable: true },
)

export const languages: Loadable<LanguageItem[]> = derived([translations], ([$translations]) => {
	return [
		{ id: null, code: 'en', name: 'English' },
		...($translations?.filter((lang) => !lang.disabled) || []),
	]
})
